import { Flex, List } from 'antd';
import ActionHeader from '../../../../components/actionHeader';
import { StyledListItem } from '../../../../styles/listItem';
import { ListContainer } from './styles';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../../store';
import {
  selectIsFetchingMachine,
  selectMachine,
} from '../../../../slices/machines';
import { useParams } from 'react-router';
import {
  fetchRoutines,
  selectCurrentRoutines,
  selectIsFetchingRoutines,
  setRoutines,
} from '../../../../slices/routines';
import RoutineCard from '../../../../components/routineCard';
import { resetSolutionGrids } from '../../../../slices/solutionGrids';

const MachineRoutines = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const machine = useSelector(selectMachine);
  const isFetchingRoutines = useSelector(selectIsFetchingRoutines);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);
  const routines = useSelector(selectCurrentRoutines);

  const isFetching = isFetchingRoutines || isFetchingMachine;

  const handleSearch = (searchText?: string) => {
    if (!isFetchingRoutines && machine?.templateID) {
      dispatch(
        fetchRoutines({
          templateID: machine.templateID,
          params: { search: searchText },
        })
      );
    }
  };

  useEffect(() => {
    if (String(machine?.machineID) !== id) {
      dispatch(setRoutines([]));
      dispatch(resetSolutionGrids());
    }
    if (machine && machine?.templateID) {
      dispatch(fetchRoutines({ templateID: machine.templateID }));
    }
  }, [machine]);

  return (
    <Flex vertical flex={1} gap={8} style={{ height: '100%' }}>
      <ActionHeader
        title="Routines"
        isSecondaryTitle
        showBorder={false}
        showSearch
        onSearch={handleSearch}
      />
      <Flex flex={1} style={{ overflowY: 'auto' }}>
        <ListContainer>
          <List
            dataSource={routines}
            loading={isFetching}
            renderItem={(item) => (
              <StyledListItem>
                <RoutineCard routine={item} />
              </StyledListItem>
            )}
          ></List>
        </ListContainer>
      </Flex>
    </Flex>
  );
};

export default MachineRoutines;
